import React from 'react';

interface ViewProps {
  width?: number;
  height?: number;
}

export const ImgStackView = ({ width = 66, height = 50 }: ViewProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 67 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1.16666"
      y="0.5"
      width="21"
      height="13"
      rx="1.5"
      stroke="#333745"
      strokeDasharray="3 3"
    />
    <rect x="3.16666" y="2.5" width="17" height="9" rx="2" fill="#F3F4F6" />
    <path
      d="M9.40634 7.62615C9.44772 7.55978 9.50526 7.50504 9.57355 7.4671C9.64184 7.42915 9.71863 7.40924 9.79671 7.40924C9.87478 7.40924 9.95158 7.42915 10.0199 7.4671C10.0882 7.50504 10.1457 7.55978 10.1871 7.62615L11.6666 9.9997H7.92636L9.40588 7.62615H9.40634Z"
      fill="#DDE0E4"
    />
    <path
      d="M12.377 5.57617C12.4152 5.49949 12.474 5.435 12.5467 5.38993C12.6194 5.34486 12.7033 5.32098 12.7888 5.32098C12.8743 5.32098 12.9581 5.34486 13.0308 5.38993C13.1035 5.435 13.1623 5.49949 13.2005 5.57617L15.4069 10.0002H10.1706L11.4798 7.37514L12.3774 5.57617H12.377Z"
      fill="#DDE0E4"
    />
    <path
      d="M9.79692 6.25033C10.4168 6.25033 10.9192 5.74657 10.9192 5.12516C10.9192 4.50375 10.4168 4 9.79692 4C9.17709 4 8.67462 4.50375 8.67462 5.12516C8.67462 5.74657 9.17709 6.25033 9.79692 6.25033Z"
      fill="#DDE0E4"
    />
    <rect
      x="27.1667"
      y="0.5"
      width="39"
      height="13"
      rx="1.5"
      stroke="#333745"
      strokeDasharray="3 3"
    />
    <rect
      x="1.16666"
      y="18.5"
      width="21"
      height="13"
      rx="1.5"
      stroke="#333745"
      strokeDasharray="3 3"
    />
    <rect x="3.16666" y="20.5" width="17" height="9" rx="2" fill="#F3F4F6" />
    <path
      d="M9.40634 25.6262C9.44772 25.5598 9.50526 25.505 9.57355 25.4671C9.64184 25.4291 9.71863 25.4092 9.79671 25.4092C9.87478 25.4092 9.95158 25.4291 10.0199 25.4671C10.0882 25.505 10.1457 25.5598 10.1871 25.6262L11.6666 27.9997H7.92636L9.40588 25.6262H9.40634Z"
      fill="#DDE0E4"
    />
    <path
      d="M12.377 23.5762C12.4152 23.4995 12.474 23.435 12.5467 23.3899C12.6194 23.3449 12.7033 23.321 12.7888 23.321C12.8743 23.321 12.9581 23.3449 13.0308 23.3899C13.1035 23.435 13.1623 23.4995 13.2005 23.5762L15.4069 28.0002H10.1706L11.4798 25.3751L12.3774 23.5762H12.377Z"
      fill="#DDE0E4"
    />
    <path
      d="M9.79692 24.2503C10.4168 24.2503 10.9192 23.7466 10.9192 23.1252C10.9192 22.5038 10.4168 22 9.79692 22C9.17709 22 8.67462 22.5038 8.67462 23.1252C8.67462 23.7466 9.17709 24.2503 9.79692 24.2503Z"
      fill="#DDE0E4"
    />
    <rect
      x="27.1667"
      y="18.5"
      width="39"
      height="13"
      rx="1.5"
      stroke="#333745"
      strokeDasharray="3 3"
    />
    <rect
      x="1.16666"
      y="36.5"
      width="21"
      height="13"
      rx="1.5"
      stroke="#333745"
      strokeDasharray="3 3"
    />
    <rect x="3.16666" y="38.5" width="17" height="9" rx="2" fill="#F3F4F6" />
    <path
      d="M9.40634 43.6262C9.44772 43.5598 9.50526 43.505 9.57355 43.4671C9.64184 43.4291 9.71863 43.4092 9.79671 43.4092C9.87478 43.4092 9.95158 43.4291 10.0199 43.4671C10.0882 43.505 10.1457 43.5598 10.1871 43.6262L11.6666 45.9997H7.92636L9.40588 43.6262H9.40634Z"
      fill="#DDE0E4"
    />
    <path
      d="M12.377 41.5762C12.4152 41.4995 12.474 41.435 12.5467 41.3899C12.6194 41.3449 12.7033 41.321 12.7888 41.321C12.8743 41.321 12.9581 41.3449 13.0308 41.3899C13.1035 41.435 13.1623 41.4995 13.2005 41.5762L15.4069 46.0002H10.1706L11.4798 43.3751L12.3774 41.5762H12.377Z"
      fill="#DDE0E4"
    />
    <path
      d="M9.79692 42.2503C10.4168 42.2503 10.9192 41.7466 10.9192 41.1252C10.9192 40.5038 10.4168 40 9.79692 40C9.17709 40 8.67462 40.5038 8.67462 41.1252C8.67462 41.7466 9.17709 42.2503 9.79692 42.2503Z"
      fill="#DDE0E4"
    />
    <rect
      x="27.1667"
      y="36.5"
      width="39"
      height="13"
      rx="1.5"
      stroke="#333745"
      strokeDasharray="3 3"
    />
  </svg>
);
